/* eslint semi:0 */
/**
 * Handles mounting React components and registering with our Redux runtime.
 */
import React from 'react'
import { nodes } from './dom'
import { render } from 'react-dom'
import { warn } from '../application/console'
import { MountedComponent } from '../application/mountedComponent'

// Safari has a bug in iOS9 and 10 sometimes it can't retrieve data attributes
// https://bugs.webkit.org/show_bug.cgi?id=161454
// workaround: https://gist.github.com/anonymous/db9f7359c81e1887fc72dd918dfe5975
function fixSafariDatasetBug(dataset) {
  return Reflect.ownKeys(dataset).filter(key => key !== 'constructor').reduce((map, key) => {
    map[key] = Reflect.get(dataset, key)
    return map
  }, {})
}

function renderMountedComponent(container, rootNode) {
  const dataset = fixSafariDatasetBug(rootNode.dataset)
  const mountedComponentProps = {
    container,
    options: { rootNode, dataset },
  }
  return render(<MountedComponent {...mountedComponentProps} />, rootNode)
}

function dispatchMountAndRender(container, domNodes) {
  return Array.from(domNodes, renderMountedComponent.bind(null, container))
}

function mountComponent(opts = {}) {
  const { container, rootSelector } = opts
  const domNodes = nodes(rootSelector)
  if (domNodes && domNodes.length > 0) {
    dispatchMountAndRender(container, domNodes)
    return true
  }
  warn(
    `Container '${container.name}' can't be mounted: '${rootSelector}' selector result is empty!`,
    { opts, container, rootSelector, domNodes }
  )
  return false
}

export default function reduxMount(selectorComponentMap = {}) {
  for (const rootSelector in selectorComponentMap) {
    const container = selectorComponentMap[rootSelector]
    if (rootSelector === 'undefined') {
      warn(
        `mountComponent selector not defined in preRenderedSelectorsConfig: `,
        selectorComponentMap
      )
      continue
    }
    mountComponent({ container, rootSelector })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/reduxMounter.js